import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Message } from 'element-ui'
import { BASE_URL } from '@/config'

const service = axios.create({
  baseURL: BASE_URL,
  timeout: 10000
})

service.interceptors.request.use(
  config => {
    const token = store.getters.token
    if (token) {
      // 与 waiqinfengweb 一致，使用 token 请求头
      config.headers.token = token
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    const config = response.config || {}
    // 业务成功码：1（与 waiqinfengweb 一致）
    if (res.code !== 1) {
      if (!config.skipErrorToast) {
        Message.error(res.msg || '请求失败')
      }
      if (res.code === 401 || res.code === 40101) {
        store.dispatch('user/logout')
        router.replace('/login')
      }
      // 允许调用方自行处理业务失败（如支付重试）
      if (config.skipBusinessReject) {
        return res
      }
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    if (error.response && error.response.status === 401) {
      store.dispatch('user/logout')
      router.replace('/login')
    }
    if (!(error.config && error.config.skipErrorToast)) {
      Message.error(error.message || '网络异常')
    }
    return Promise.reject(error)
  }
)

export default service
